import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const WorkspaceLoginConfigResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
});
export class WorkspaceLoginConfigResponseDto extends createZodDto(WorkspaceLoginConfigResponseSchema) {
}
